(ns teamoesterreich.admin-mode.warnings.warnung-measure-setup
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.warningMeasure :as d-warningMeasure]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            ))





(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        l-date (if (> cell-data 893462400000)
                 (h-date/print-google-date (h-date/parse-unix-date cell-data))
                 "-")
        ]
    (js/console.log l-date)
    (r/as-element
      [:span l-date])))



(defn edit-cell-renderer [!selected]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (if (d-rights/is-superuser?)
          [mui/icon-button {:label   "bearbeiten"
                            :onClick #(reset! !selected cell-data)
                            } [edit {:fontSize "small"}]]
          [:span ""])))))


(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !selected (r/cursor !st [:selected])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !show-inactive (r/cursor !st [:show-inactive])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 250)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc
                                          :invalidated true
                                          :sort (aget s "sortBy")
                                          :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "OrganisationList"}
         (log/debug "rerender " m " @!show-inactive " @!show-inactive " @!sort " @!sort " @!reverse " @!reverse rows)

         [:> rv/Column
          {:label        "#"
           :dataKey      (name :warningMeasure-uuid)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !selected)
           :width        70}]

         [:> rv/Column
          {:label     "Typ"
           :dataKey   (name :_warningMeasure-typeName)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden" :text-align "left"}
           :width     200}]
         [:> rv/Column
          {:label     "Level"
           :dataKey   (name :warningMeasure-level)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden"}
           :width     100}]


         [:> rv/Column
          {:label     "Massnahme"
           :dataKey   (name :warningMeasure-measure)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden"}
           :width     520}]

         ]))))


(defn filter-fn [data !st]
  ;(log/debug "filter-fn " (count rows) search)
  (filter (fn [[k e]] (re-find (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split (:search @!st) " ")))
                               (str (:_warningMeasure-typeName e) "#" (:warningMeasure-measure e))))
          data))

(defn update-list [!st]
  (h/update-table-list !st d-warningMeasure/<get-warningMeasure-list {:filter-fn filter-fn :default-sort :_warningMeasure-typeName}))



(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn warnMeasure-form [!data !selected !loaded?]

  (let [d-warningMeasure (get @!data @!selected)]

    ;[:pre (h/pretty-map d-warningMeasure)]
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    3
      }
     [mui/grid
      {:container false :item true
       :md        6
       :xs        12
       :style     {:padding "15px"}
       }
      [:h3 "Warnung Maßnahme " [:br] "`" (:_warningMeasure-typeName d-warningMeasure) "` Level " (:warningMeasure-level d-warningMeasure)]
      [edit-md-card/get-it (:warningMeasure-measure d-warningMeasure)
       (fn [d]
         (d-warningMeasure/>warningMeasure-edit (:warningMeasure-uuid d-warningMeasure) {:warningMeasure-measure d}
                                                (fn []
                                                  (reset! !selected nil)
                                                  (reset! !loaded? false))))
       ""
       {:additional-button [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 10px"}
                                        :onClick   #(reset! !selected nil)
                                        }
                            "Zurück"]}
       ]

      [:br]
      [:br]
      ]]))

(defn get-it []
  (let [!st (r/atom {:rows {} :loaded nil :create-modal-show nil :sort :_warningMeasure-typeName})
        !loaded? (r/cursor !st [:loaded])
        !rows (r/cursor !st [:rows])
        !selected (r/cursor !st [:selected])
        !data (r/cursor !st [:data])]
    (fn []

      (let [
            ]

        (update-list !st)
        (if (not @!loaded?)

          (do [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])


          [mui/paper



           [mui/grid
            {:container  true
             :direction  "row"
             :alignItems "stretch"
             :justify    "flex-start"
             :spacing    1
             :style      {:marginTop "15px" :height "100%" :minHeight "400px"}
             }

            [mui/grid
             {:item true
              :lg   2
              :md   3
              :xs   6
              }

             ]
            [mui/grid
             {:item true
              :lg   8
              :md   6
              :xs   6
              :type {:textAlign "bottom"}
              }
             [mui/typography {:variant "h5" :padding "5px 0 0 0"}
              " Warnung Maßnahmen Liste "]
             ]
            [mui/grid
             {:item true
              :lg   2
              :md   3
              :xs   6
              }
             [ws-event-sync-component/ws-event-reload !loaded? :warning]
             ]
            [mui/grid
             {:item true
              :xs   12
              }
             (if @!selected
               [warnMeasure-form !data !selected !loaded?]
               [get-table !st !rows])
             ]
            ]

           ]))

      )))





